
import { Helmet } from 'react-helmet';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { EOLFeed } from '@/components/EOLFeed';
import { useLanguage } from '@/hooks/useLanguage';

const EOL = () => {
  const { t } = useLanguage();

  return (
    <>
      <Helmet>
        <title>{t('eol.pageTitle')} | Cybermonit</title>
      </Helmet>
      <Navbar />
      <main>
        <EOLFeed />
      </main>
      <Footer />
    </>
  );
};

export default EOL;
